module.exports = require('./providerOfIsClass')('ArrayBuffer');
